import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	settings: {
		defaultMessage: 'Settings',
		id: 'atlassian-navigation.settings.menu.settings',
		description: 'Settings',
	},
});
